
import { defineAsyncComponent, defineComponent } from 'vue';
import BackPageButton from '@/components/BackPageButton.vue';

export default defineComponent({
  components: {
    BaseIcon: defineAsyncComponent(() => import('@/components/BaseIcon.vue')),
    BackPageButton,
  },
});
